// ======================================================================
// File Name       : UserDetailContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {
  searchUser,
  getAttributeListForUser,
  getUserCourseRelationList,
  getChildUserList,
  getAuthorityList,
  getGroupList,
  userEdit,
  getGroupCourseRelation,
  getUserGroupRelation,
  getGroupListAll,
  sendAccountInfo,
} from '../../actions/UserAction';
import UserDetail from '../../components/user/UserDetail';
import UserDelConfirm from '../../components/DialogConfirm';
import { SELECT_TARGET_DATA, MODE } from '../../constants/index';
import { USER_EDIT } from '../../constants/FunctionConstants';
import { MSG_DEL_USER, MSG_SEND_ACCOUNT_INFO } from '../../constants/MessageTemplate';
import { USER_TYPE } from '../../constants/UserConstants';
import { USER_LIST, USER } from '../../constants/PathConstants';
import { canAccess } from '../../utils/AuthedUtils';
import Header from '../../components/Header';
import { isSuperUser } from '../../utils/index';
import CustomLink from '../../components/button/CustomLink';
import * as Path from '../../constants/PathConstants';
import DialogConfirm from '../../components/DialogConfirm';

class UserDetailContainer extends Component {
  constructor() {
    super();
    this.state = {
      showDelete: false,
      userDetail: {
        userSecernId: null,
        groupRelationList: [],
      },
      userAttributes: {
        byKeyNum: {},
        allKeyNums: [],
      },
      groupInfo: {
        bySecernId: {},
        allSecernIds: [],
      },
      managementAuthoritys: {
        bySecernId: {},
        allSecernIds: [],
      },
      groupList: [],
      courseList: [],
      childUserList: [],
      isGetChildList: false,
      openSendAccountInfoDialog: false, // Step 9.0.1
    };

    this.openDeleteDialog = this.openDeleteDialog.bind(this);
    this.onOkDelete = this.onOkDelete.bind(this);
    this.onCancelDelete = this.onCancelDelete.bind(this);
    // Step 9.0.1 START
    this.openSendAccountInfoDialog = this.openSendAccountInfoDialog.bind(this);
    this.onSendAccountInfoCancel = this.onSendAccountInfoCancel.bind(this);
    this.onSendAccountInfoOk = this.onSendAccountInfoOk.bind(this);
    // Step 9.0.1 END
  }

  componentDidMount() {
    const { match } = this.props;
    this.getDataforUserDetail(match.params.id);
  }

  componentWillReceiveProps(nextProps) {
    const { user, match, dispatch } = nextProps;
    const {
      userInfo,
      managementAuthoritys,
      userAttributes,
      userGroupRelations,
      groupInfo,
      groupList,
      courseList,
      childUserList,
      userCourseRelation,
    } = user;
    const userDetail = userInfo.bySecernId[match.params.id];
    // Get child user
    if (!userDetail) {
      const userSecernIdList = [match.params.id];
      const searchInfo = {
        dormantState: true,
      };
      dispatch(searchUser(searchInfo, userSecernIdList));
    } else if (
      userDetail.userType === USER_TYPE.GUARDIAN &&
      childUserList.length === 0 &&
      !this.state.isGetChildList
    ) {
      dispatch(getChildUserList(userDetail.userSecernId));
      const isGetChildList = true;
      this.setState({ isGetChildList });
    }
    this.setState({
      userDetail,
      managementAuthoritys,
      userAttributes,
      userGroupRelations,
      groupInfo,
      groupList,
      courseList,
      childUserList,
      userCourseRelation,
    });
  }

  getDataforUserDetail(userSecernId) {
    if (userSecernId) {
      const { dispatch } = this.props;
      dispatch(getGroupListAll()).then(() => {
        dispatch(getAttributeListForUser(userSecernId));
        dispatch(getUserCourseRelationList(userSecernId));
      });
    }
  }

  /**
     * Show delete User confirm dialog
     * @param mdContent
     * @param mdSize
     */
  openDeleteDialog() {
    this.content = MSG_DEL_USER;
    this.setState({ showDelete: true });
  }

  /**
     * Cancel delete SuperUser
     */
  onCancelDelete() {
    this.setState({ showDelete: false });
  }

  /**
     * Confirm delete user
     */
  onOkDelete() {
    const param = {
      editType: MODE.DELETE_MODE,
      userInfo: {
        userSecernId: this.state.userDetail.userSecernId,
      },
    };
    const self = this;
    this.props.dispatch(userEdit(param)).then(() => {
      self.props.history.push(USER_LIST);
    });
    this.setState({ showDelete: false });
  }

  // Step 9.0.1 START
  openSendAccountInfoDialog(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ openSendAccountInfoDialog: true });
  }

  onSendAccountInfoCancel() {
    this.setState({ openSendAccountInfoDialog: false });
  }

  onSendAccountInfoOk() {
    const { userDetail } = this.state;
    const { dispatch } = this.props;

    // Call アカウント情報送信API
    dispatch(sendAccountInfo(userDetail.userSecernId));
    this.setState({ openSendAccountInfoDialog: false });
  }
  // Step 9.0.1 END

  render() {
    const canEditDelete = canAccess(USER_EDIT);
    const { userDetail } = this.state;
    const link = userDetail ? `/${USER}/${userDetail.userSecernId}/edit` : '';
    let allGroupList = this.state.groupList;
    if (this.props.user.allGroup && this.props.user.allGroup.length) {
      allGroupList = this.props.user.allGroup;
    }
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.USER_LIST}
          text="ユーザー管理に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name="ユーザー情報の詳細" />
        {userDetail && <UserDetail {...this.state} allGroupList={allGroupList} />}
        <Col sm={12} className="text-center margin-top-20 padding-left-15">
          {/* Step 9.0.1 START */}
          {userDetail && userDetail.userType !== USER_TYPE.ADMIN && (
            <Button
              variant='primary'
              className='btn-96 margin-top-10 float-left'
              onClick={this.openSendAccountInfoDialog.bind(this, MSG_SEND_ACCOUNT_INFO, null)}
            >
              パスワード再発行
            </Button>
          )}
          {/* Step 9.0.1 END */}
          {canEditDelete &&
          <Link
            className="btn btn-primary btn-96 margin-10"
            role="button"
            to={link}
          >
            編集
          </Link>}
          {canEditDelete &&
          <Button
            variant="primary"
            className="btn-96 margin-10"
            onClick={this.openDeleteDialog}
          >
            削除
          </Button>}
        </Col>
        <UserDelConfirm
          showModal={this.state.showDelete}
          onCancel={this.onCancelDelete}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onOkDelete}
        />
        {/* Step 9.0.1 START */}
        <DialogConfirm
          showModal={this.state.openSendAccountInfoDialog}
          onCancel={this.onSendAccountInfoCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onSendAccountInfoOk}
        />
        {/* Step 9.0.1 END */}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...{ user: state.user, userFunctions: state.authed },
});

export default connect(mapStateToProps)(UserDetailContainer);
